import { action, observable, makeObservable } from "mobx";
import { validateEmail } from "utils/validateEmail";

export class TeamsWidgetStore {
  usersEmail: string = null;
  isInTeams = false;

  constructor() {
    makeObservable(this, {
      usersEmail: observable,
      isInTeams: observable,
      setContext: action.bound,
    });
  }

  setContext(ctx) {
    if (ctx) {
      this.isInTeams = true;
      const loginHint = ctx.loginHint;
      const userPrincipalName = ctx.userPrincipalName;
      if (validateEmail(loginHint)) {
        this.usersEmail = loginHint;
      } else if (validateEmail(userPrincipalName)) {
        this.usersEmail = userPrincipalName;
      }
    }
  }
}

export const teamsWidgetStore = new TeamsWidgetStore();
